// extracted by mini-css-extract-plugin
export default {"container":"banner-planos_container__TxSE4","lista-planos":"banner-planos_lista-planos__QZJgw"};